import React from "react";
import {
  Container,
  Typography,
  Box,
  Button,
  Paper,
  Link,
  Divider,
  Fade,
  Tooltip,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import useUser from "../hooks/useUser";


export default function AccesoDenegado() {
  const navigate = useNavigate();
  const user = useUser();
  // console.log(user)

  return (
    <Fade in timeout={600}>
      <Container maxWidth="sm" sx={{ mt: 12 }}>
        <Paper
          elevation={10}
          sx={{
            p: 6,
            borderRadius: 6,
            textAlign: "center",
            background: "linear-gradient(135deg, #ffffff, #f0f4f8)",
            boxShadow: "0 12px 32px rgba(0,0,0,0.1)",
            transition: "transform 0.3s ease",
            ":hover": {
              transform: "scale(1.01)",
            },
          }}
        >
          <Box sx={{ mb: 4 }}>
            <LockOutlinedIcon sx={{ fontSize: 80, color: "#c62828" }} />
          </Box>
          <Typography variant="h4" sx={{ fontWeight: 700, color: "#263238", mb: 2 }}>
            Acceso Restringido
          </Typography>
          <Typography variant="body1" sx={{ color: "#546e7a", mb: 3 }}>
            <strong style={{ fontWeight: "bold", color: "#f57c00" }}>No tienes autorización para visualizar esta sección o no te encuentras autenticado. </strong> Este contenido está limitado a usuarios con permisos específicos.
          </Typography>
          <Divider sx={{ mb: 3 }} />
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mb: 2 }}>
            <MailOutlineIcon sx={{ mr: 1, color: "#1976d2" }} />
            <Tooltip title="Haz clic para enviar un correo" arrow>
              <Link
                href="mailto:soporteit@cixsa.com"
                underline="hover"
                sx={{
                  fontWeight: 600,
                  color: "#1976d2",
                  fontSize: "1rem",
                  transition: "color 0.3s ease",
                  ":hover": {
                    color: "#0d47a1",
                  },
                }}
              >
                soporteit@cixsa.com
              </Link>
            </Tooltip>
          </Box>
          <Typography variant="body2" sx={{ color: "#78909c", mb: 4 }}>
            Si consideras que esto es un error, por favor contacta al equipo de soporte técnico.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate("/login")}
            sx={{
              textTransform: "none",
              fontWeight: "bold",
              px: 5,
              py: 1.5,
              fontSize: "1rem",
              borderRadius: 3,
              boxShadow: 3,
              transition: "background-color 0.3s ease",
              ":hover": {
                backgroundColor: "#1565c0",
              },
            }}
          >
            Volver al inicio
          </Button>
        </Paper>
      </Container>
    </Fade>
  );
}